import { appstr } from "../utils/appstr";
import { appstrp } from "../utils/appstrp";
import { Div2Floor } from "../utils/Div2Floor";
import { gHelpRef } from "../constants";
import { LaunchHelpCode } from "../utils/LaunchHelpCode";
import { gHelpWiki, gUseGenericSupportContact } from "@coreapp/whitelabel/brand";

export class QAlert {
  constructor() {
    this.fParentPanel = null;
    this.fOKCode = null;
    this.fNoCode = null;
    this.fTertCode = null;
    this.fYesCode = null;
    this.fYesStr = null;
    this.fNoStr = null;
    this.fTertStr = null;
    this.fPostCancelCode = null; // Linked to exiting.
    this.fCloseAfterSelection = true;
    this.fNoCmdParameters = {};
    this.fYesCmdParameters = {};
    this.fTertCmdParameters = {};
    this.fHasExit = true;
    this.fHasDragger = false;
    this.fHasFooter = false;
    this.fHeaderStr = "";
    this.fHasSupportLink = false;
    this.fCenterOnBackgroundPanel = true;
    this.fTextContentCSSClasses = "";

    this.fOnConfirmFn = null;
    this.fOnDenyFn = null;
    this.fOnTertiaryFn = null;
    this.fOnDismissFn = null;
  }

  InitAlert(headerStr, message, parentPanel, wsMgr, addSupportLink, id, otherProps) {
    this.fOKCode = "OK";
    this.fYesStr = appstr("OK");
    this.fHasSupportLink = addSupportLink;
    this.fHelpLinkCode = "launchSupport";
    this.CommonInit(wsMgr, parentPanel, headerStr, message, id, undefined, otherProps);
  }

  InitSaveAlert(wsMgr, parentPanel, yesCode, noCode) {
    var yesStr = appstr("Save");
    var noStr = appstr("Discard");
    this.InitConfirmAlert(
      appstrp("Save Changes", "?"),
      appstr("genericsave"),
      parentPanel,
      wsMgr,
      yesCode,
      noCode,
      yesStr,
      noStr
    );
  }

  InitCodeAlert(
    headerStr,
    message,
    parentPanel,
    wsMgr,
    cmdCode,
    yesStr,
    yesCmds = null,
    id = null,
    restrictDismiss = undefined
  ) {
    this.fOKCode = cmdCode;
    this.fYesStr = yesStr;
    this.fYesCmdParameters = yesCmds;
    this.CommonInit(wsMgr, parentPanel, headerStr, message, id, restrictDismiss);
  }
  InitConfirmAlert(
    headerStr,
    message,
    parentPanel,
    wsMgr,
    yesCode,
    noCode,
    yesStr,
    noStr,
    yesCmdParameters = null,
    noCmdParameters = null,
    id = null
  ) {
    this.fConfirmAlert = true;
    this.fYesCode = yesCode;
    this.fNoCode = noCode == null ? "" : noCode; // Defaults noCode to '' if not provided.
    this.fYesCmdParameters = yesCmdParameters;
    this.fNoCmdParameters = noCmdParameters;

    this.fYesStr = yesStr == null ? appstr("Yes") : yesStr;
    this.fNoStr = noStr == null ? appstr("No") : noStr;
    this.CommonInit(wsMgr, parentPanel, headerStr, message, id);
  }

  InitOKAlert(headerStr, message, parentPanel, wsMgr, yesCode, noCode) {
    this.fConfirmAlert = true;
    this.fYesCode = yesCode;
    this.fNoCode = noCode;

    this.fYesStr = appstr("OK");
    this.fNoStr = appstr("Cancel");

    this.CommonInit(wsMgr, parentPanel, headerStr, message);
  }

  InitConfirmAlertCustom(
    headerStr,
    message,
    parentPanel,
    wsMgr,
    yesCode,
    noCode,
    yesStr,
    noStr,
    yesCmdParameters = null,
    noCmdParameters = null,
    id = null
  ) {
    this.fConfirmAlert = true;
    this.fCornerButtons = true;
    this.fYesCode = yesCode;
    this.fNoCode = noCode;

    this.fYesStr = yesStr;
    this.fNoStr = noStr;

    this.fYesCmdParameters = yesCmdParameters;
    this.fNoCmdParameters = noCmdParameters;
    this.CommonInit(wsMgr, parentPanel, headerStr, message, id);
  }

  InitHelpLinkAlert(headerStr, message, parentPanel, wsMgr, helpLinkCode, helpLinkLabel) {
    this.fOKCode = "OK";
    this.fYesStr = appstr("OK");
    this.fHasHelpLink = true;
    this.fHelpLinkCode = helpLinkCode;
    this.fHelpLinkLabel = helpLinkLabel;
    this.fCloseAfterSelection = false;
    this.CommonInit(wsMgr, parentPanel, headerStr, message);
  }

  InitReactConfirmAlert(
    onClickConfirm,
    onClickDeny,
    confirmStr,
    denyStr,
    onDismiss = undefined,
    tertiaryStr = undefined,
    onClickTertiary = undefined
  ) {
    this.fOnConfirmFn = onClickConfirm;
    this.fOnDenyFn = onClickDeny;
    this.fOnDismissFn = onDismiss;
    this.fYesStr = confirmStr == null ? appstr("Yes") : confirmStr;
    this.fNoStr = denyStr == null ? appstr("No") : denyStr;
    this.fTertStr = tertiaryStr;
    this.fOnTertiaryFn = onClickTertiary;
    this.fConfirmAlert = !!onClickConfirm && !!onClickDeny;
  }

  LookupMessageCode(errorCodeOrMessage) {
    const errorMap = {
      noMatchingRecords: {
        title: appstr("iwizerr1"),
        message: appstr(
          "No results found for the selected criteria. Please adjust your selection and try again"
        ),
        hasSupportLink: false
      }
    };

    if (!(errorCodeOrMessage in errorMap)) {
      return;
    }

    const error = errorMap[errorCodeOrMessage];

    if (error.title) this.fHeaderStr = error.title;
    if (error.message) this.fMessage = error.message;
    if (error.hasSupportLink != null) this.fHasSupportLink = error.hasSupportLink;
  }

  CommonInit(
    wsMgr,
    parentPanel,
    header,
    errorCodeOrMessage,
    id = null,
    restrictDismiss = false,
    otherProps
  ) {
    this.fParentPanel = parentPanel;
    this.fWSMgr = wsMgr;
    this.fMessage = errorCodeOrMessage;
    this.fHeaderStr = header;
    this.LookupMessageCode(errorCodeOrMessage);

    let eventData = {
      title: this.fHeaderStr,
      message: this.fMessage,
      parent: parentPanel,
      ref: this
    };

    if (id != null) eventData.id = id;
    if (restrictDismiss) eventData.restrictDismiss = restrictDismiss;

    if (this.fConfirmAlert) {
      let confirm = {};
      confirm.label = this.fYesStr;
      confirm.code = this.fYesCode;
      confirm.params = this.fYesCmdParameters;
      confirm.customOnClick = this.fOnConfirmFn;
      eventData.confirm = confirm;

      let deny = {};
      deny.label = this.fNoStr;
      deny.code = this.fNoCode;
      deny.params = this.fNoCmdParameters;
      deny.customOnClick = this.fOnDenyFn;
      eventData.deny = deny;

      if (this.fTertStr) {
        let tertiary = {};
        tertiary.label = this.fTertStr;
        tertiary.code = this.fTertCode;
        tertiary.params = this.fTertCmdParameters;
        tertiary.customOnClick = this.fOnTertiaryFn;
        eventData.tertiary = tertiary;
      }

      if (this.fOnDismissFn) {
        let dismiss = {};
        dismiss.onDismiss = this.fOnDismissFn;
        eventData.dismiss = dismiss;
      }
    } else {
      let confirm = {};
      confirm.label = this.fYesStr;
      confirm.code = this.fOKCode;
      confirm.params = this.fYesCmdParameters;
      confirm.customOnClick = this.fOnConfirmFn;
      eventData.confirm = confirm;
    }

    var addHelpLink = this.fHasSupportLink || this.fHasHelpLink;
    if (addHelpLink) {
      let helpLink = {};
      if (this.fHasSupportLink && !this.fHasHelpLink && gUseGenericSupportContact) {
        helpLink.label = appstr("genericSupportDeskHelp");
        helpLink.href = null;
      } else {
        var supportMsg1 = appstr("supportdeskhelp");
        var supportMsg2 = appstr("supportdeskhelp2");
        var helpRef = gHelpWiki;
        var helpLabel = this.fHelpLinkLabel
          ? this.fHelpLinkLabel
          : supportMsg1 + " " + supportMsg2 + ".";
        if (this.fHasHelpLink) {
          var langCode = "en";
          var helpPath = this.fHelpLinkCode
            ? langCode + "/" + gHelpRef[this.fHelpLinkCode].join("/")
            : "";
          helpRef = LaunchHelpCode(helpPath, true);
        }
        helpLink.label = helpLabel;
        helpLink.href = helpRef;
      }
      eventData.helpLink = helpLink;
    }
    wsMgr.handleAlert({ ...eventData, ...otherProps });
  }

  AutoFitElementsHorz(elemList) {
    var fsMin = 10;
    var minMargin = 10;

    elemList.forEach(function (item) {
      var fs = parseFloat(window.getComputedStyle(item, null).getPropertyValue("font-size"));
      if (fs >= fsMin) fs--;
      item.style.fontSize = fs.toString() + "px";
    });
    var elemsInBounds = this.CheckElementsInHorzBounds(elemList);
    if (elemsInBounds) return;
    var curFS = parseFloat(
      window.getComputedStyle(elemList[0], null).getPropertyValue("font-size")
    );
    if (curFS < fsMin) {
      var maximumWidth = Div2Floor(this.GetAvailableWidth() - minMargin * 3);
      elemList.forEach(function (item) {
        item.style.maxWidth = maximumWidth;
      });
      return;
    }

    this.AutoFitElementsHorz(elemList);
  }

  ExecuteBasicCommands() {
    // hack to bypass basic cmd handling for html panel for now
    return false;
  }

  SetPostCancelCode(code) {
    this.fPostCancelCode = code;
  }

  AttachCmdParams(button, params) {
    if (params != null) {
      for (var aKey in params) button.AddCmdParameter(aKey, params[aKey]);
    }
  }

  PostStandardResize() {
    this.CenterOnBackgroundPanel();
  }

  ExecuteCustomCommand(aCmd) {
    // override this
    return false;
  }

  // TODO clean up this mess
  ExecuteCommand(aCmd) {
    var cmdCode = aCmd.GetCmdCode();
    var wsMgr = aCmd.GetWSMgr();
    var doPostCancelAction = false;
    var panelHandled = cmdCode === "closePanel" || cmdCode === this.fPostCancelCode;
    if (cmdCode === "0000") {
      return;
    }
    if (cmdCode === "launchSupport") {
      window.open(gHelpWiki);
    }
    if (this.fPostCancelCode && (cmdCode === "closePanel" || cmdCode === this.fPostCancelCode)) {
      doPostCancelAction = true;
      aCmd.fCmdCode = this.fPostCancelCode;
    }
    if (!panelHandled) {
      panelHandled = this.ExecuteCustomCommand(aCmd);
    }
    if (this.fCloseAfterSelection || cmdCode === "OK") {
      // t//his.DoClosePanel();
    }
    if (this.fParentPanel && (!panelHandled || doPostCancelAction)) {
      panelHandled = this.fParentPanel.ExecuteAlertCommand(aCmd);
    } else if (cmdCode == this.fYesCode) {
      panelHandled = !doPostCancelAction;
    }

    return panelHandled;
  }
}
